import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AddVaultQuestionsPageNew from "../../components/VaultQuestions/AddVaultQuestionsPageNew";



const AddVaultQuestionsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Vault Questions" link2="/vault-questions" title="Add Vault Question" />

        {/* AddUserLayer */}
        <AddVaultQuestionsPageNew/>


      </MasterLayout>
    </>
  );
};

export default AddVaultQuestionsPage;
